const AppState = {
  hasModalOpen: false
};

export default AppState;
